var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"full-icon",on:{"click":_vm.onSwitchFull}},[_c('a-icon',{attrs:{"type":!_vm.full ? 'fullscreen' : 'fullscreen-exit',"fill":"#fff"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }